import { useCallback, useState } from 'react';
import { ContactOption } from '../../types/contact';

/**
 * Tracks the contacts picked in the email form so their emails can be mapped
 * back to task tags.
 */
export const useEmailContactSelection = () => {
  const [selectedContacts, setSelectedContacts] = useState<ContactOption[]>([]);

  const onContactSelect = useCallback(
    (contact: ContactOption) =>
      setSelectedContacts(prev => [
        ...prev.filter(({ id }) => id !== contact.id),
        contact,
      ]),
    []
  );

  return { selectedContacts, onContactSelect };
};
